// extracted by mini-css-extract-plugin
export default {"NavButtonA":"third_NavButtonA__ELjjG","NavButton":"third_NavButton__muxSn"};